import { useEffect} from 'react';
import { connect } from 'react-redux';
import { useParams } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";


import { InAppTemplate } from "../../../shared/templates/inapp";

import { history } from "../../../shared/_helpers/history";

import "../index.scss"
import { AlertMsg } from "../../../shared/components/alert-msg"
import { LoadingItem } from "../../../shared/components/loading"
import { storeActions } from "../../../redux/actions/in-app"

import {
        EditProductForm,
        MainHeader, 
        getProductDetail,
        getMetadata,
        addNewProduct,
        editProduct,
        getImagesGallery,
} from './utils/edit';





const InAppContent = ({ pageProps }: any) => {
    const { productId } = useParams();

    useEffect(() => {
        if (productId) {
            getMetadata({
                pageProps,
                // payload: "CLEAR"
            })
            getImagesGallery({
                pageProps,
                payload: "CLEAR"
            })

            getProductDetail({
                pageProps,
                payload: productId
            })

            addNewProduct({
                pageProps,
                payload: "CLEAR"
            })
            editProduct({
                pageProps,
                payload: "CLEAR"
            })
        } else {
            history.replace("/app/my-products")
        }


    }, [])

    return (
        <div className="inapp-content">
            <div className="page-content form-page">

                {/* <div className="addproduct-heading">
                    <h3>Edit Product</h3>
                    <div className="addproduct-top">Get the right market for your products. Edit your products here and get set to sell them on mamiMarket</div>
                </div> */}
                {(pageProps.getAProductRequest.request_status === "GET_A_PRODUCT_SUCCESS" &&
                    pageProps.getProductMetaDataRequest.request_status === "GET_PRODUCT_META_SUCCESS") &&
                    <EditProductForm pageProps={pageProps} />
                }
                {pageProps.getAProductRequest.request_status === "GET_A_PRODUCT_PENDING" &&
                    <LoadingItem />
                }
                {pageProps.getAProductRequest.request_status === "GET_A_PRODUCT_FAILURE" &&
                    <AlertMsg type="error" message={pageProps.getAProductRequest?.request_data.error} />
                }
                {pageProps.getProductMetaDataRequest.request_status === "GET_A_PRODUCT_FAILURE" &&
                    <AlertMsg type="error" message={pageProps.getProductMetaDataRequest?.request_data.error} />
                }
            </div>
        </div>
    )
}
const EditProduct = (pageProps: any) => {
    // const { productId } = useParams();
    // useEffect(() => {


    //         getProductDetail({
    //             pageProps,
    //             payload: "CLEAR"
    //         })



    // }, [])
    return (
        <InAppTemplate pageHeadingTitle="Edit Product" showMainPageHeading={true} mainPageHeading={<MainHeader />} childComponent={<InAppContent pageProps={pageProps} />} />
    )
}

const mapDispatchToProps = {
    updateProductAction: storeActions.UpdateStoreProduct,
    getMetadataAction: storeActions.GetProductMetaData,
    getImageGalleryAction: storeActions.GetImageGallery,
    getAProduct: storeActions.GetAProduct,
    uploadProductImageAction: storeActions.UploadProductImage,
};

const mapStateToProps = (state: any) => ({
    // return {
    // allImagesGallery: ()=>{
    //     return 
    // },
    getProductMetaDataRequest: state.allProductReducers.getProductMetaDataReducer,
    updateStoreProductRequest: state.allProductReducers.updateStoreProductReducer,
    getImageGalleryRequest: state.allProductReducers.getImageGalleryReducer,
    createStoreProductRequest: state.allProductReducers.createStoreProductReducer,
    getAProductRequest: state.allProductReducers.getAProductReducer,
    updateProductImageRequest: state.allProductReducers.updateProductImageReducer,

    // };
})
export default connect(mapStateToProps, mapDispatchToProps)(EditProduct);